import { render, staticRenderFns } from "./ChannelsContainer.vue?vue&type=template&id=fafc300a"
import script from "./ChannelsContainer.vue?vue&type=script&lang=js"
export * from "./ChannelsContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports